(function() {
    'use strict';
    angular.module('sgnmrApp').config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('historial-normativo', {
            parent: 'public',
            url: '/historial/{id}',
            data: { authorities: [], pageTitle: 'sgnmrApp.norma.historico.title' },
            views: {
                'content@public': {
                    templateUrl: 'app/home/historial-normativo.html',
                    controller: 'HistorialNormativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('tipoDisposicion');
                    $translatePartialLoader.addPart('tipoModificacion');
                    return $translate.refresh();
                }],
                norma: ['$stateParams', 'PublicNorma', function($stateParams, PublicNorma) {
                    return PublicNorma.get({id: $stateParams.id}).$promise;
                }],
                historial: ['$stateParams', 'PublicNorma', function($stateParams, PublicNorma) {
                    return PublicNorma.getHistorial({id: $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
